import { HttpError } from "@nestia/fetcher";
import api from "@api";
import { getConnection } from "@app/sdk";

import type { CreateOrderDTO } from "./dto";

const mapToServerPayload = (dto: CreateOrderDTO) => ({
  ...dto,
  docNumber: dto.docNumber,
  lines: dto.lines.map((line) => ({
    quantity: Number(line.quantity),
    note: line.item?.name || "",
    productId: line.item && line.item.id > 0 ? line.item.id : null,
  })),
});

export const createOrder = async (orderDTO: CreateOrderDTO) => {
  try {
    return await api.functional.orders.createPreorder(
      getConnection(),
      mapToServerPayload(orderDTO),
    );
  } catch (e) {
    if (e instanceof HttpError) {
      throw new Error(`Order creation failed: ${e.message}`);
    }
    throw e;
  }
};
